module.exports = __webpack_public_path__ + "static/media/pe.017a482a.svg";